/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.15"
        height="84.14"
        viewBox="0 0 82.15 84.14"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M66.83 13.6a8.38 8.38 0 0 1 8.35 8.1v5.54a1.25 1.25 0 0 1-2.49.12v-5.41a5.88 5.88 0 0 0-5.63-5.85H63.8a1.25 1.25 0 0 1-.12-2.49h3.15ZM28.37 13.6a1.25 1.25 0 0 1 .13 2.49H16.9a1.25 1.25 0 0 1-.13-2.49h11.6Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M61.41 6.96a1.25 1.25 0 0 1 1.55.71v.12l5.23 17.52a1.25 1.25 0 0 1-2.35.84v-.12l-4.87-16.3L8.6 26.86a1.24 1.24 0 0 1-1.53-.68v-.12a1.25 1.25 0 0 1 .63-1.56h.12Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M53.12.15a1.24 1.24 0 0 1 1.64.43l.06.11 4.08 8.1a1.25 1.25 0 0 1-2.17 1.24l-.07-.12-3.49-6.95L8.8 26.77a1.24 1.24 0 0 1-1.62-.39l-.07-.12a1.24 1.24 0 0 1 .39-1.62l.12-.07Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M16.9 13.6a1.25 1.25 0 0 1 .13 2.49H6.66a4.161 4.161 0 0 0-.2 8.32h63a8.38 8.38 0 0 1 8.35 8.1v12.53a1.25 1.25 0 0 1-2.49.13v-12.4a5.87 5.87 0 0 0-5.63-5.84H6.66a6.661 6.661 0 0 1-.23-13.32H16.9Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M2.5 20.55v55.24a5.87 5.87 0 0 0 5.63 5.84H69.5a5.88 5.88 0 0 0 5.85-5.64v-12h2.5v11.74a8.37 8.37 0 0 1-8.1 8.34H8.35A8.38 8.38 0 0 1 0 75.97V20.55Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M80.9 43.85H60.19c-5.18 0-9.8 4.93-9.8 10.65a10.64 10.64 0 0 0 10.64 10.65H80.9a1.25 1.25 0 0 0 1.25-1.25V45.1a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v16.3H61.03a8.15 8.15 0 0 1-8.14-8.15v-.25c.13-4.27 3.61-7.9 7.3-7.9Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M64.14 54.5a3.1 3.1 0 1 1-3.1-3.09 3.09 3.09 0 0 1 3.1 3.09"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'WalletIcon';

export default Icon;
